"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.breakpoints = void 0;
exports.breakpoints = {
    phone: '@media (min-width: 576px)',
    tablet: '@media (min-width: 768px)',
    desktop: '@media (min-width: 992px)',
    largeDesktop: '@media (min-width: 1200px)',
};
